import(/* webpackMode: "eager" */ "/vercel/path0/packages/examples/src/components/shared/RevizOutput.tsx")